import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  ManualsCreatedOrUpdatedData,
  ManualCreatedOrUpdatedData,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { ManualsUpdatedConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "manuals-updated-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class ManualsUpdatedChartComponent
  extends BaseChartLogic<ManualsUpdatedConfig, ManualsCreatedOrUpdatedData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      ManualsUpdatedConfig,
      _ngZone
    );
    this.handleDataSubscription(this.analyticsService.manualsUpdatedDataChange);
  }

  dataPointKey: string = "Total";
  protected getDataPointDisplayValue(
    dataPoint: ManualCreatedOrUpdatedData
  ): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
  }

  refreshData(): void {
    this.analyticsService.getUpdatedManualsData(this.filterSettings);
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
